import React, { memo } from 'react'
import { Link } from 'react-router-dom'

import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import clsx from 'clsx';
import useStyles from '../styles/Styles'

import _ from 'lodash';

const InvoicesHelp = memo(({helpOpen, handleChange, isSm, invoiceSettings}) => {
		
	const classes = useStyles();
	
	let office_methods = [];
	if(invoiceSettings.accept_eftpos_at_office){
		office_methods.push('by EFTPOS')
	}
	if(invoiceSettings.accept_cheques_at_office){
		office_methods.push('by cheque made out to ' + invoiceSettings.make_cheques_out_to);
	}
	if(invoiceSettings.accept_cash_at_office){
		office_methods.push('in cash');
	}
	
	return (
			<Dialog
			open={helpOpen}
			onClose={() => handleChange(false)}
			fullScreen={!isSm}
			aria-labelledby="help-dialog-title"
			className={clsx(classes.settingsDialog, classes.otherContent)}
			>
			<DialogTitle id="help-dialog-title">Invoices Help</DialogTitle>
			<DialogContent dividers>
			
			<Typography variant='h5' component='h2' gutterBottom>
            Finding and viewing invoices
			</Typography>
          <Typography gutterBottom>
          Invoices are displayed in date order, most recent first. By default, invoices created within the past year are loaded. You can adjust the date range using the SETTINGS button.
          </Typography>
		  <Typography gutterBottom>Also in SETTINGS, you can choose whether to view paid and/or zero-value invoices.</Typography>
		  <Typography gutterBottom>Invoices that require payment are <Box component='span' sx={{
			  color: 'error.main'
		  }}>highlighted in red text</Box>.</Typography>
		  <Typography paragraph>To view details for any invoice, simply click on that invoice in the list.</Typography>
		  
		  <Typography variant='h5' component='h2' gutterBottom>
            Paying invoices
			</Typography>
			
			{invoiceSettings.paypal.accept ? 
			<>
			<Typography variant='h6' component='h3'>
			Paying with PayPal
			</Typography>
			<Typography variant="body1">
			PayPal is a fast and secure way to pay online. You can pay using a PayPal account, or with a credit card. To pay with PayPal:
			</Typography>
			<ol>
			<li><Typography gutterBottom>Click on the required invoice to open the invoice details.
			</Typography></li>
			<li><Typography gutterBottom>Click the PAY WITH PAYPAL button at the bottom of the invoice.
			</Typography></li>
			<li><Typography gutterBottom>You will be taken to the PayPal site, where you can follow the prompts to either log in to your PayPal account or provide your credit card details and confirm the payment.
			</Typography></li>
			<li><Typography paragraph>After confirming the payment, you will usually be returned to U-MAS. If you are not automatically returned to U-MAS, look for a "Return to seller's website" button or link.
			</Typography></li>
			</ol>
			</>
			: null}
			
			{invoiceSettings.bank.accept ? 
			<>
			<Typography variant='h6' component='h3'>
			Paying by bank transfer
			</Typography>
			{invoiceSettings.bank.use_payid ? 
			<>
			<Typography gutterBottom>
			We recommend using our PayID, below, as it is safer for you than keying our BSB/Account Number.
			Check with your financial institution on how to use PayID, as each bank may implement it differently.
			</Typography>
			<Typography paragraph>
			{invoiceSettings.bank.payid_detail}<br/>
			<strong>Be sure to include your Invoice ID as the reference!</strong>
			</Typography>
			</> : 
			<>
			<Typography gutterBottom>
			You can pay by bank deposit or Electronic Funds Transfer (EFT), using the details below. These details are also displayed at the bottom of each invoice.
			</Typography>
			<Typography paragraph>
			{invoiceSettings.bank.detail}<br/>
			<strong>Be sure to include your Invoice ID as the reference!</strong>
			</Typography>
			</> }
			</>
			: null }
			
			{_.isEmpty(office_methods) ? null : 
			<>
			<Typography variant='h6' component='h3'>
			Paying at the office
			</Typography>
			<Typography paragraph>
			We accept payment at the office, {_.join(office_methods, ', or ')}.
			{invoiceSettings.accept_cheques_at_office ? 
			<>
			<br/>
			<strong>If paying by cheque, please write your Invoice ID on the back.</strong>
			</>
			: null}
			</Typography>
			</>}
			
			{invoiceSettings.accept_cheques_via_post ?
			<>
			<Typography variant='h6' component='h3'>
			Paying by mail
			</Typography>
			<Typography paragraph>
			We accept cheques by mail. Please make the cheque out to <strong>{invoiceSettings.make_cheques_out_to}</strong>, and mail it to:<br/>
			{invoiceSettings.formal_name}<br/>
			{invoiceSettings.postal_address}<br/>
			<strong>Please write your Invoice ID on the back of the cheque.</strong>
			</Typography>
			</>
			: null}
			
			{!invoiceSettings.paypal.accept && !invoiceSettings.bank.accept &&  invoiceSettings.accept_cheques_via_post && _.isEmpty(office_methods)? 
			<Typography paragraph>Please <Link to="/contact">contact us</Link> to find out how to pay your invoices.</Typography>
			: null }
			
			<Typography variant='h5' component='h2' gutterBottom>
            Downloading or printing invoices
			</Typography>
			<Typography gutterBottom>You can generate a PDF version of any invoice, which you can then download to your computer and/or print:</Typography>
			<ol>
			<li><Typography gutterBottom>Click on the required invoice to open the invoice details.
			</Typography></li>
			<li><Typography gutterBottom>Click the PDF button at the bottom of the invoice.
			</Typography></li>
			<li><Typography paragraph>A PDF file will be generated, and a DOWNLOAD button will be displayed: Click this button to download the PDF.
			</Typography></li>
			</ol>
			
			</DialogContent>
			<DialogActions>
          <Button autoFocus onClick={() => handleChange(false)} color="primary">
            Close
          </Button>
        </DialogActions>
		</Dialog>
)})

export default InvoicesHelp;